export default __webpack_public_path__ + "static/media/welcomecard.10efb9cf.jpg";